/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubjectContactResponseDto } from './subjectContactResponseDto.model';
import { ListinDto } from './listinDto.model';


/**
 * JPV section type of \'e\'
 */
export interface JpvSectionEDto { 
    cisloRizeni?: string;
    listin: ListinDto;
    nazev?: string;
    opsubGroup?: string;
    pravniUcinky?: string;
    subjectContact: SubjectContactResponseDto;
    zapisProveden?: string;
    zeDne?: string;
    zhotovitel?: string;
    zkratka?: string;
}

